"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxLoadingState = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Spinner = require("../Spinner/Spinner");
var _ComboboxLoadingState = require("./ComboboxLoadingState.styles");
/**
 * @since 8.28.0
 */
var ComboboxLoadingState = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_ComboboxLoadingState.StyledComboboxLoadingState, (0, _extends2.default)({
    ref: forwardedRef
  }, props), /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, {
    size: "md",
    title: "Loading"
  }));
});
exports.ComboboxLoadingState = ComboboxLoadingState;
ComboboxLoadingState.displayName = 'ComboboxLoadingState';